import DetailTitle from "@/components/DetailTitle"
import styles from './index.module.scss'
import { RollbackOutlined } from '@ant-design/icons';
import { getComments, replyComment, deleteComment } from "@/apis/discover"
import { useEffect, useState, useMemo } from 'react';
import { Form, Input, Button, Tooltip, message } from 'antd';
import intl from "react-intl-universal";
import { useSelector, useDispatch } from 'react-redux';
import { setIsOpen } from "@/store/modules/user";
import { DeleteOutlined } from '@ant-design/icons';
import CommentAuthor, { getAuthorName, canDeleteComment } from "./CommentAuthor";
const { TextArea } = Input;
const Comments = ({ resourceUuid, time }) => {
	const { userInfo } = useSelector(state => state.user)
	const [list, setList] = useState([])
	const [isShow, setIsShow] = useState(false);
	const [form] = Form.useForm()
	const useName = useMemo(() => userInfo?.username, [userInfo])

	const [commentUUid, setCommentUUid] = useState('')
	const [placeholder, setPlaceholder] = useState('')
	const dispatch = useDispatch()

	// 获取评论列表
	const getList = () => {
		getComments({
			resourceUuid: resourceUuid
		}).then(res => {
			setList(Array.isArray(res.data) ? res.data.filter(Boolean) : []);
		});
	}

	// 回复评论
	const reply = (uuid, parentName) => {
		setIsShow(true);
		setCommentUUid(uuid)
		setPlaceholder(`${useName} ${intl.get("Share.reply to")} ${parentName}：`)
	}

	// 取消回复
	const cancelReply = () => {
		setIsShow(false);
		setCommentUUid('')
	}

	// 删除评论
	const deleteUuid = (uuid) => {
		deleteComment({
			commentUuid: uuid
		}).then(res => {
			message.success(intl.get("deleted successfully"))
			getList()
			cancelReply()
		})
	}

	const onFinish = (values) => {
		if (!useName) {
			dispatch(setIsOpen(true))
		} else {
			replyComment({
				parentUuid: commentUUid,
				commentContent: values.comment
			}).then(res => {
				form.resetFields();
				cancelReply();
				getList();
			})
		}
	}

	useEffect(() => {
		getList()
	}, [resourceUuid, time])

	return <div className={styles.commentsBox}>
		<DetailTitle title="Comments" />
		{list.length > 0 && list.map((item, index) => {
			return (
				<div className={styles.listBox} key={item.commentUuid}>
					<p>
						<i><CommentAuthor user={item.user} status={item.authorStatus} /></i>
						<span>{item.createTime}</span>
					</p>
					<div>
						{item.commentStatus === "DELETED" ? intl.get("Share.Comment deleted") : item.commentContent}
						{(item.commentStatus !== "DELETED" && (!isShow || item.commentUuid !== commentUUid)) && <a href="#" onClick={() => reply(item.commentUuid, getAuthorName(item.user, item.authorStatus))}><RollbackOutlined style={{ marginRight: "5px" }} />{intl.get("Reply")}</a>}
						{(isShow && item.commentUuid === commentUUid) && <a href="#" onClick={cancelReply}><RollbackOutlined style={{ marginRight: "5px" }} />{intl.get("Cancel Reply")}</a>}
						{
							canDeleteComment(item, userInfo) &&
							<Tooltip title={intl.get("Delete")}>
								<DeleteOutlined onClick={() => deleteUuid(item.commentUuid)} className={styles.deleteBox} />
							</Tooltip>
						}
					</div>

					{(isShow && item.commentUuid === commentUUid) &&
						<Form
							onFinish={onFinish}
							autoComplete="off"
							form={form}
							className={styles.formBox}
						>
							<Form.Item
								label=""
								name="comment"
								rules={[
									{
										required: true,
										message: intl.get('Share.Please input your comment'),
									},
								]}
							>
								<TextArea rows={5} placeholder={placeholder} />
							</Form.Item>

							<Form.Item>
								<Button htmlType="submit" type="primary">{intl.get('CommentBtn')}</Button>
							</Form.Item>
						</Form>
					}

					{Array.isArray(item.children) && <div className={styles.replyBox}>
						{item.children.filter(Boolean).map(son => {
							return (
								<div key={son.commentUuid}>

									{son.commentLevel < 2 && <span><CommentAuthor user={son.user} status={son.authorStatus} />：</span>}
									{son.commentLevel > 1 && <span><CommentAuthor user={son.user} status={son.authorStatus} /> {intl.get("Share.reply to")} <CommentAuthor user={son.replyUser} status={son.replyAuthorStatus} />：</span>}

									{son.commentStatus === "DELETED" ? intl.get("Share.Comment deleted") : son.commentContent}

									{(son.commentStatus !== "DELETED" && (!isShow || son.commentUuid !== commentUUid)) && <a onClick={() => reply(son.commentUuid, getAuthorName(son.user, son.authorStatus))}><RollbackOutlined style={{ marginRight: "5px" }} />{intl.get("Reply")}</a>}
									{(isShow && son.commentUuid === commentUUid) && <a onClick={cancelReply}><RollbackOutlined style={{ marginRight: "5px" }} />{intl.get("Cancel Reply")}</a>}
									{
										canDeleteComment(son, userInfo) &&
										<Tooltip title={intl.get("Delete")}>
											<DeleteOutlined onClick={() => { deleteUuid(son.commentUuid) }} className={styles.deleteBox} />
										</Tooltip>
									}
									<i>{son.createTime}</i>


									{(isShow && son.commentUuid === commentUUid) &&
										<Form
											onFinish={onFinish}
											autoComplete="off"
											form={form}
											className={styles.formBox}
										>
											<Form.Item
												label=""
												name="comment"
												rules={[
													{
														required: true,
														message: intl.get('Share.Please input your comment'),
													},
												]}
											>
												<TextArea rows={5} placeholder={placeholder} />
											</Form.Item>
											<Form.Item>
												<Button htmlType="submit" type="primary">{intl.get('CommentBtn')}</Button>
											</Form.Item>
										</Form>
									}
								</div>
							)
						})}
					</div>}
				</div>
			)
		})}
		{list.length === 0 && <div className={styles.noYet}>{intl.get("Share.No comments yet")}</div>}
	</div>
}
export default Comments